var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['message-abstract-image-container']},[_c('img',{class:['message-abstract-image'],attrs:{"src":_vm.imageUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }